import AuthRoutes from '@routes/Auth'
import DashboardRoutes from '@routes/Dashboard'

export default [
	...AuthRoutes,
	...DashboardRoutes
]
